// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"57d513a0","937":"80b8dfe4"}[chunkId] + ".chunk.js";
};